// removed by extract-text-webpack-plugin
module.exports = {"Tabs":"tabList__Tabs__22OZX","Tab":"tabList__Tab__2ZeCh","ActiveTab":"tabList__ActiveTab__3K-TT","Notifications":"tabList__Notifications__tCaTH","NotificationCount":"tabList__NotificationCount__3yjQH"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Navigation/TabList/tabList.css
// module id = 895
// module chunks = 2